export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";